import { NavThirdLevelButton } from "bimui"
import { ReactComponent as MatSvg } from 'bimui/dist/c1/icons/material.svg';
import { ReactComponent as SecSvg } from 'bimui/dist/c1/icons/section.svg';
import { ReactComponent as ConstructSvg } from 'bimui/dist/c1/icons/construction.svg';
import { ReactComponent as CalSvg } from 'bimui/dist/c1/icons/calculation-method.svg';
import { useContext } from "react";
import { RegisterContext } from "@/App";
import { SIDEBAR_TYPE } from "@/declare/enums/menu-type";

/**
 * 用于注册的系统库菜单
 */
export default function SystemLibMenu() {

    const registerContext = useContext(RegisterContext);

    const onClickMenu = (key: string) => {
        registerContext.activeSidebar(key)
    }

    return (
        <>
            <div className='second-level-nav-group'>
                <NavThirdLevelButton icon={<MatSvg />}
                    disabled
                // active={registerContext.currentActivedSidebarKey === SystemLibPanelKey.MATERIAL}
                // onClick={() => onClickMenu(SystemLibPanelKey.MATERIAL)}
                >材料</NavThirdLevelButton>
                <NavThirdLevelButton icon={<SecSvg />}
                    disabled
                // active={registerContext.currentActivedSidebarKey === SystemLibPanelKey.SECTION}
                //     onClick={() => onClickMenu(SystemLibPanelKey.SECTION)}
                >截面</NavThirdLevelButton>
                <NavThirdLevelButton icon={<ConstructSvg />}
                    disabled
                // active={registerContext.currentActivedSidebarKey === SystemLibPanelKey.DEVICE}
                //     onClick={() => onClickMenu(SystemLibPanelKey.DEVICE)}
                >设备</NavThirdLevelButton>

            </div>
            <div className='second-level-nav-group'>
                <NavThirdLevelButton icon={<CalSvg />} active={registerContext.currentActivedSidebarKey === SIDEBAR_TYPE.SYSTEM_PARAM}
                    onClick={() => onClickMenu(SIDEBAR_TYPE.SYSTEM_PARAM)}>参数</NavThirdLevelButton>
            </div>
        </>
    )
}